import { Component, Inject, OnDestroy, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AbstractControl, FormBuilder, FormGroup, ValidatorFn, Validators } from "@angular/forms";
import { CodeModifyModalComponent } from "./code-modify-modal.component";
import { MatDialog } from "@angular/material/dialog";
import { ResultModalComponent } from "../../../component/result-modal/result-modal.component";
import { DefaultActionFactory, DefaultActionFactoryToken, DefaultState } from "@core/redux/redux.module";
import { Store } from "@ngrx/store";
import { Observable, Subject } from "rxjs";
import { DEFAULT_STATE_NAME } from "@core/redux/reducer/default/default.reducer";
import { LocalStoreService } from "../../../core/index";
import { StatusType } from "@api/index";
import { take } from "rxjs/operators";
import {
  SessionHandlerService,
  SessionHandlerServiceToken, SessionManagerService, SessionManagerServiceToken
} from "../../core/session/session.module";

@Component({
  templateUrl: "secure-code-modify.component.html"
})
export class SecureCodeModifyComponent implements OnInit, OnDestroy {

  private _destroy$: Subject<boolean> = new Subject<boolean>();
  public modifyFormGroup: FormGroup;
  private actionFactory: DefaultActionFactory;
  private defaultState: Observable<DefaultState>;

  public statuses: any[];
  public cardLastNumbers: string = null;
  public ownerName: string = null;

  constructor(
    protected router: Router,
    private formBuilder: FormBuilder,
    protected dialog: MatDialog,
    private ngStore: Store<any>,
    @Inject(DefaultActionFactoryToken)
      defaultActionFactory: DefaultActionFactory,
    @Inject(SessionHandlerServiceToken)
      protected _sessionHandler: SessionHandlerService,
    @Inject(SessionManagerServiceToken)
      protected _sessionManager: SessionManagerService,
  ) {
    this.defaultState = ngStore.select(DEFAULT_STATE_NAME);
    this.actionFactory = defaultActionFactory;
    this.modifyFormGroup = this.formBuilder.group({
      secureCode: [{value: "", disabled: true}, []],
      status: [null, []]
    });
    this.defaultState.subscribe( (state: DefaultState)  => {
      this.modifyFormGroup.get("secureCode").setValue(state?.staticPassword || null);
      this.modifyFormGroup.get("status").setValue(state?.status || null);
      this.cardLastNumbers = "**********" + ( state?.cardLastNumber || LocalStoreService.get()?.cardLastNumber );
      this.ownerName = state?.ownerName || LocalStoreService.get()?.ownerName;
      this._sessionManager.restoreTimeOuts();
    });
  }

  ngOnInit(): void {
    this.modifyFormGroup.get("status").setValidators([this.isBanned(), this.isBlocked()]);
    this.modifyFormGroup.get("status").markAsTouched();
    this.modifyFormGroup.get("status").updateValueAndValidity();
  }

  ngOnDestroy() {
    if (this.dialog) {
      this.dialog.closeAll();
    }
    this._destroy$.next(true);
    this._destroy$.unsubscribe();
  }

  isBanned(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      return this.modifyFormGroup.get("status").value === StatusType.BANNED ? { "banned": true } : null;
    };
  }

  isBlocked(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: boolean } | null => {
      return this.modifyFormGroup.get("status").value === StatusType.BLOCKED ? { "blocked": true } : null;
    };
  }

  canBeActivated(): boolean {
    return ![StatusType.ACTIVE, StatusType.BANNED].includes(this.modifyFormGroup.get("status").value);
  }

  public logout() {
    this.actionFactory.logout().subscribe( state => {
      this._sessionHandler.logout();
    }, error => {
      // a kívánt működés nem ismert
      this._sessionHandler.logout();
    });
  }

  public modifyCode() {
    const data =  this.modifyFormGroup.get("secureCode").value;
    const dialogRef = this.dialog.open(CodeModifyModalComponent, {
      data,
      disableClose: false,
      width: "600px",
      autoFocus: false,
      panelClass: "mkb-card3dsecure-modal"
    });

    dialogRef.afterClosed().subscribe(resp => {
      if (resp) {
        if (resp.success) {
          this.modifyFormGroup.get("secureCode").setValue(resp.data.secureCode);
          this.modifyFormGroup.get("status").setValue(StatusType.ACTIVE);
          this.actionFactory.changeState({
            staticPassword: resp.data.secureCode,
            status: StatusType.ACTIVE
          }).pipe(take(1)).subscribe();
          this.success("code");
        } else {
          this.failed("code");
        }
      }
    });
  }

  public activate() {
    const req = {
      staticPassword: this.modifyFormGroup.get("secureCode").value
    };
    this.actionFactory.activateCard(req).pipe().subscribe( resp => {
      this.modifyFormGroup.get("status").setValue(StatusType.ACTIVE);
      this.actionFactory.changeState({
        status: StatusType.ACTIVE
      }).pipe(take(1)).subscribe();
      this.success();
    }, error => {
      this.failed();
    });
  }

  public success(type?: string) {
    const data = {
      success: true,
      message: type === "code" ?
        "mkb.card3dsecure.modal.result.modify.success.title" :
        "mkb.card3dsecure.modal.result.activation.success.title"
    };
    this.dialog.open(ResultModalComponent, {
      data,
      disableClose: false,
      width: "600px",
      autoFocus: false,
      panelClass: "result-modal"
    });
  }

  public failed(type?: string) {
    const data = {
      success: false,
      message: type === "code" ?
        "mkb.card3dsecure.modal.result.modify.failed.title" :
        "mkb.card3dsecure.modal.result.activation.failed.title"
    };
    this.dialog.open(ResultModalComponent, {
      data,
      disableClose: false,
      width: "600px",
      autoFocus: false,
      panelClass: "result-modal"
    });
  }
}
